<select class="form-control" [(ngModel)]="selectedAgency" (change)="onChange()">
    <option [ngValue]="undefined">{{'Dashboard_Filter_AllAgencies' | localize}}</option>
    <option *ngFor="let agency of agencies" [ngValue]="agency.agency.id">{{agency.agency.companyName}}</option>
</select>
